import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const AccentButton = ({ 
  children, 
  to, 
  onClick, 
  type = "button", 
  className = "",
  variant = "primary" // primary (orange) или outline (white)
}) => {
  
  // Базовые стили из твоего HomeHero
  const baseStyles = "inline-flex items-center justify-center py-4 px-8 rounded-[20px] font-[900] uppercase tracking-wider text-[13px] transition-all duration-300 active:scale-95 text-center";
  
  const variants = {
    primary: "bg-[#F65814] text-white shadow-[0_12px_24px_-6px_rgba(246,88,20,0.3)] hover:-translate-y-1 hover:shadow-[0_20px_30px_-10px_rgba(246,88,20,0.4)]",
    outline: "bg-white text-[#0A1128] border border-slate-200 hover:bg-slate-50 hover:border-slate-300"
  };

  const combinedStyles = `${baseStyles} ${variants[variant]} ${className}`;

  // Если передан проп 'to', рендерим Link, иначе обычную кнопку
  if (to) {
    return (
      <Link to={to} className={combinedStyles}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={combinedStyles}>
      {children}
    </button>
  );
};

export default AccentButton;